<template>
    <div class="resultados-busqueda-lid">
        <table>
            <thead>
                <tr>
                    <th>Fecha</th>
                    <th>Título</th>
                    <th v-if="!isSelectedResults">Resumen</th>
                    <th class="text-center">Seleccionar</th>
                    <th v-if="isSelectedResults">Instrucciones</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="result in results" :key="result.url" @mouseover="hover = result.url" @mouseleave="hover = null" :class="{ hover: hover === result.url }">
                    <td>{{ formatDate(result.date) }}</td>
                    <td><a :href="`https://laizquierdadiario.com/${result.url}`" target="_blank">{{ result.title }}</a></td>
                    <td v-if="!isSelectedResults">{{ result.summary }}</td>
                    <td class="text-center">
                        <button v-if="!isSelectedResults" @click="selectResult(result)">Seleccionar</button>
                        <button v-else @click="deselectResult(result)">Deseleccionar</button>
                    </td>
                    <td v-if="isSelectedResults">
                        <input type="text" placeholder="Instrucciones" @input="updateInstructions(result, $event.target.value)">
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
    props: {
        results: {
            type: Array,
            required: true
        },
        isSelectedResults: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            hover: null
        };
    },
    methods: {
        formatDate(date) {
            const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
            return new Date(date).toLocaleDateString('en-GB', options).replace(',', '');
        },
        selectResult(result) {
            this.$emit('select-lid-result', result);
        },
        deselectResult(result) {
            this.$emit('deselect-lid-result', result);
        },
        updateInstructions(result, value) {
            this.$emit('update-lid-instructions', { result, value });
        }
    }
}
</script>
<style scoped>
.resultados-busqueda-lid {
    margin-top: 12px;
    background-color: #555;
    padding: 12px;
    margin-bottom: 24px;
}
.hover {
    background-color: #000;
}

table {
    width: 100%;
    font-size: 12pt;
}

.text-center {
    text-align: center;
}

td {
    font-size: 13pt;
    padding: 3px;

}

td input {
    width: 100%;
    min-width: 200px;
}
td button {
    padding: 4px 8px;
    background-color: #802632;
    color: #fff;
    border: none;
    cursor: pointer;
    font-size: 13pt;
}
</style>